// Small maps (catch form, catch details) get an enlarge button that opens them over the whole screen.
import { el, icon } from "../dom.ts";
import { t } from "../i18n.ts";
import type { CentredMap } from "./layers.ts";

/** Closes the enlarged small map, when one is open (the back button and dialog close use this first). */
export let collapseMini: (() => void) | null = null;

/** Adds the enlarge button and the "Done" bar to `box`. Returns a function to open (true) or close (false) it. */
export function makeExpandable(box: HTMLElement, getMap: () => CentredMap | null, hintText?: () => string): (on: boolean) => void {
  const hint = el("span", { class: "fullhint" });
  const open = el("button", { class: "btn expand", type: "button", "aria-label": t("mapExpand") }, icon("expand"));
  const done = el("button", { class: "btn primary", type: "button" }, t("done"));
  const set = (on: boolean) => {
    box.classList.toggle("full", on);
    open.hidden = on;
    collapseMini = on ? () => set(false) : null;
    if (on) hint.textContent = hintText ? hintText() : "";
    const m = getMap();
    if (m) requestAnimationFrame(() => { m.invalidateSize(); if (m.centre) m.panTo(m.centre()); });
  };
  open.addEventListener("click", () => set(true));
  done.addEventListener("click", () => set(false));
  box.append(open, el("div", { class: "fullbar" }, hint, done));
  return set;
}
